import {omit, difference, keys, keyBy, createReducer} from 'helpers';
import {RootState} from 'store/types';
import {ServerActions} from 'store/server';
import {isPredefined} from '../selectors';

export const templates = createReducer<RootState['activities']['templates'], ServerActions>({}, {
  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.activities);
    const templates = action.activities
      .filter(isPredefined)
      .map((activity) => ({
        id: activity.id,
        name: activity.name,
        note: activity.note,
        goal_id: activity.goal_id,
        isTemplate: activity.isTemplate,
        habitTypeId: activity.habitTypeId
      }));
    if (templates.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(templates, 'id'),
      }, removed);
    }
    return state;
  },

  SERVER_DATA_RECEIVED_AFTER: (state) => state,

  TESTING_DELETE_ALL: (state) => state,
});
